// extracted by mini-css-extract-plugin
export default {"noMatchFoundText":"DashboardNextFollowUpList_noMatchFoundText__uGHv8"};